/** Generated from docs/research/dir-individuals.json (read from official sources, verified 2026-11-03). Details marked `needsCheck` could not be fully verified; the UI tells people to confirm on the official page. */
export interface IndividualEntry {
  id: string; name: string; organization: string; audience: "individual" | "business" | "both"; category: string; whatFor: string
  urls: { label: string; url: string }[]; phone: string | null; costNote: string | null; needsCheck: boolean; verifiedOn: string
}
export interface IndividualStep { n: number; text: string; sourceUrl: string }
export const INDIVIDUAL_ENTRIES: IndividualEntry[] = [
  {
    "id": "ftc-identitytheft-gov",
    "name": "IdentityTheft.gov",
    "organization": "Federal Trade Commission",
    "audience": "individual",
    "category": "report",
    "whatFor": "The FTC site where a person can report identity theft and get a recovery plan (page's own description: step-by-step advice to limit damage, report identity theft and fix credit).",
    "urls": [
      {
        "label": "IdentityTheft.gov home (meta description read)",
        "url": "https://www.identitytheft.gov/"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-credit-freeze-fraud-alert",
    "name": "FTC: Credit freezes and fraud alerts",
    "organization": "Federal Trade Commission",
    "audience": "both",
    "category": "credit",
    "whatFor": "Explains that a freeze blocks new accounts until lifted, and that initial (1 year), extended (7 years, needs an identity theft or police report) and active duty (1 year) fraud alerts ask businesses to verify identity.",
    "urls": [
      {
        "label": "What to know about credit freezes and fraud alerts",
        "url": "https://consumer.ftc.gov/articles/what-know-about-credit-freezes-fraud-alerts"
      }
    ],
    "phone": null,
    "costNote": "free (page states freezes and all three fraud alert types are free)",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-model-breach-notice",
    "name": "FTC Data Breach Response: A Guide for Business (notify individuals and model letter)",
    "organization": "Federal Trade Commission",
    "audience": "business",
    "category": "guidance",
    "whatFor": "Business guide whose notification section and model letter (written for stolen Social Security numbers) cover what happened, what was involved, what the business is doing, and what recipients can do, and suggests offering at least a year of free credit monitoring and pointing people to IdentityTheft.gov.",
    "urls": [
      {
        "label": "Data Breach Response: A Guide for Business",
        "url": "https://www.ftc.gov/business-guidance/resources/data-breach-response-guide-business"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-child-identity-theft",
    "name": "FTC: How to protect your child from identity theft",
    "organization": "Federal Trade Commission",
    "audience": "individual",
    "category": "guidance",
    "whatFor": "Describes free credit freezes for children under 16 (16 and 17 year olds can request their own), and asking all three bureaus for a manual search to see whether a child has a credit report.",
    "urls": [
      {
        "label": "How to protect your child from identity theft",
        "url": "https://consumer.ftc.gov/articles/how-protect-your-child-identity-theft"
      }
    ],
    "phone": null,
    "costNote": "credit freeze for a child under 16 is free; cost of manual search not stated",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "equifax-security-freeze",
    "name": "Equifax security freeze",
    "organization": "Equifax",
    "audience": "individual",
    "category": "credit",
    "whatFor": "Equifax's page for placing, temporarily lifting or removing a security freeze on an Equifax report; a freeze at Equifax does not cover Experian or TransUnion.",
    "urls": [
      {
        "label": "Equifax credit freeze",
        "url": "https://www.equifax.com/personal/credit-report-services/credit-freeze/"
      }
    ],
    "phone": "(888) 298-0045",
    "costNote": "free (page states placing, lifting and removing a freeze is free)",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "experian-security-freeze",
    "name": "Experian security freeze and fraud alert",
    "organization": "Experian",
    "audience": "individual",
    "category": "credit",
    "whatFor": "Experian's page on its security freeze (blocks most inquiries until removed, no effect on score) and fraud alert; online freeze via a free Experian account.",
    "urls": [
      {
        "label": "Experian credit freeze",
        "url": "https://www.experian.com/help/credit-freeze/"
      }
    ],
    "phone": "1-888-397-3742",
    "costNote": "security freeze and fraud alert listed as free",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "transunion-freeze-fraud-alert",
    "name": "TransUnion credit freeze and fraud alert",
    "organization": "TransUnion",
    "audience": "individual",
    "category": "credit",
    "whatFor": "TransUnion's own credit freeze and fraud alert pages.",
    "urls": [
      {
        "label": "TransUnion credit freeze (blocked, not read)",
        "url": "https://www.transunion.com/credit-freeze"
      },
      {
        "label": "TransUnion fraud alerts (blocked, not read)",
        "url": "https://www.transunion.com/credit-help/fraud-alerts"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "annualcreditreport",
    "name": "AnnualCreditReport.com",
    "organization": "Equifax, Experian, TransUnion (per FTC: the authorized site)",
    "audience": "individual",
    "category": "credit",
    "whatFor": "Per the FTC, the only authorized site for ordering free credit reports; FTC says each bureau's report can be checked weekly for free and a free copy is also available every 12 months by request.",
    "urls": [
      {
        "label": "FTC: Free credit reports",
        "url": "https://consumer.ftc.gov/articles/free-credit-reports"
      },
      {
        "label": "AnnualCreditReport.com (JavaScript app, no content readable)",
        "url": "https://www.annualcreditreport.com/"
      }
    ],
    "phone": "1-877-322-8228 (printed on FTC page, not on the site itself)",
    "costNote": "free per FTC page",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "irs-identity-theft-guide",
    "name": "IRS: Identity theft guide for individuals",
    "organization": "Internal Revenue Service",
    "audience": "individual",
    "category": "tax-and-government",
    "whatFor": "Lists steps for tax-related identity theft: stop engaging the thief, follow IRS letters, report it, follow IdentityTheft.gov steps, get an IP PIN, keep records, keep filing, and when to use Form 14039.",
    "urls": [
      {
        "label": "Identity theft guide for individuals",
        "url": "https://www.irs.gov/identity-theft-central/identity-theft-guide-for-individuals"
      }
    ],
    "phone": "800-908-4490 (identity and return verification line; 800-829-1040 for tax account questions)",
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "irs-ip-pin",
    "name": "IRS Identity Protection PIN (IP PIN)",
    "organization": "Internal Revenue Service",
    "audience": "individual",
    "category": "tax-and-government",
    "whatFor": "A six-digit number that keeps someone else from filing a return with your SSN or ITIN; available through the IRS online account or app, Form 15227, or in person.",
    "urls": [
      {
        "label": "Get an Identity Protection PIN",
        "url": "https://www.irs.gov/identity-theft-fraud-scams/get-an-identity-protection-pin"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "irs-data-breach-taxpayers",
    "name": "IRS: Data breach information for taxpayers",
    "organization": "Internal Revenue Service",
    "audience": "individual",
    "category": "tax-and-government",
    "whatFor": "Tax-season guidance after a breach: tax accounts are mainly at risk when SSN and financial data are exposed; file Form 14039 if you get IRS identity theft correspondence or a duplicate-SSN rejection; keep filing even on paper.",
    "urls": [
      {
        "label": "Data breach information for taxpayers",
        "url": "https://www.irs.gov/identity-theft-fraud-scams/data-breach-information-for-taxpayers"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ssa-block-electronic-access",
    "name": "Social Security: my Social Security and blocking electronic access",
    "organization": "Social Security Administration",
    "audience": "individual",
    "category": "tax-and-government",
    "whatFor": "SSA guidance on protecting your Social Security record, including requesting a block on electronic access.",
    "urls": [
      {
        "label": "my Social Security (blocked, not read)",
        "url": "https://www.ssa.gov/myaccount/"
      },
      {
        "label": "SSA publication EN-05-10220 (blocked, not read)",
        "url": "https://www.ssa.gov/pubs/EN-05-10220.pdf"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cfpb-complaint",
    "name": "CFPB: Submit a complaint",
    "organization": "Consumer Financial Protection Bureau",
    "audience": "individual",
    "category": "report",
    "whatFor": "Complaint intake for problems with products such as credit reports, credit cards, bank accounts, debt collection and loans.",
    "urls": [
      {
        "label": "Submit a complaint",
        "url": "https://www.consumerfinance.gov/complaint/"
      }
    ],
    "phone": "(855) 411-2372 (TTY (855) 729-2372), 9am-6pm ET Mon-Fri except federal holidays",
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "itrc",
    "name": "Identity Theft Resource Center",
    "organization": "Identity Theft Resource Center (nonprofit)",
    "audience": "individual",
    "category": "support",
    "whatFor": "Nonprofit victim assistance for identity theft.",
    "urls": [
      {
        "label": "ITRC FAQ (blocked, not read)",
        "url": "https://www.idtheftcenter.org/faq/"
      },
      {
        "label": "ITRC home (blocked, not read)",
        "url": "https://www.idtheftcenter.org/"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "no-more-ransom",
    "name": "No More Ransom",
    "organization": "No More Ransom Project (Dutch police, Europol EC3, Kaspersky, McAfee per its About page)",
    "audience": "both",
    "category": "tools",
    "whatFor": "Site describing itself as a repository of keys and applications that can decrypt data locked by some ransomware, run as law enforcement and IT security partners; it advises not paying and says not every ransomware has a solution.",
    "urls": [
      {
        "label": "Home",
        "url": "https://www.nomoreransom.org/en/index.html"
      },
      {
        "label": "About the project",
        "url": "https://www.nomoreransom.org/en/about-the-project.html"
      },
      {
        "label": "Decryption tools",
        "url": "https://www.nomoreransom.org/en/decryption-tools.html"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "fbi-ic3",
    "name": "FBI Internet Crime Complaint Center (IC3)",
    "organization": "Federal Bureau of Investigation",
    "audience": "both",
    "category": "report",
    "whatFor": "FBI-run intake for cyber-enabled crime and fraud; victims are encouraged to file even if unsure, IC3 cannot respond to every report, and child exploitation goes to NCMEC.",
    "urls": [
      {
        "label": "IC3",
        "url": "https://www.ic3.gov/"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "hhs-ocr-complaint",
    "name": "HHS OCR health information privacy complaint",
    "organization": "HHS Office for Civil Rights",
    "audience": "individual",
    "category": "report",
    "whatFor": "Complaint route for alleged HIPAA Privacy, Security or Breach Notification Rule violations by covered entities or business associates.",
    "urls": [
      {
        "label": "Filing a complaint (blocked, not read)",
        "url": "https://www.hhs.gov/hipaa/filing-a-complaint/index.html"
      },
      {
        "label": "Complaint process (blocked, not read)",
        "url": "https://www.hhs.gov/hipaa/filing-a-complaint/complaint-process/index.html"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "naag-find-my-ag",
    "name": "NAAG: Find my AG",
    "organization": "National Association of Attorneys General",
    "audience": "individual",
    "category": "report",
    "whatFor": "Directory of each state, DC and territory attorney general, who is the chief legal officer; click to open profiles.",
    "urls": [
      {
        "label": "Find my AG",
        "url": "https://www.naag.org/find-my-ag/"
      }
    ],
    "phone": null,
    "costNote": null,
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  }
]
export const INDIVIDUAL_STEPS: IndividualStep[] = [
  {
    "n": 1,
    "text": "Report the identity theft and get a recovery plan at IdentityTheft.gov, which the site describes as step-by-step advice to limit damage, report identity theft and fix credit.",
    "sourceUrl": "https://www.identitytheft.gov/"
  },
  {
    "n": 2,
    "text": "Consider a fraud alert (one bureau notifies the others) or a credit freeze (each bureau separately); the FTC says both are free.",
    "sourceUrl": "https://consumer.ftc.gov/articles/what-know-about-credit-freezes-fraud-alerts"
  },
  {
    "n": 3,
    "text": "Review credit reports; the FTC names AnnualCreditReport.com as the only authorized site for free reports.",
    "sourceUrl": "https://consumer.ftc.gov/articles/free-credit-reports"
  },
  {
    "n": 4,
    "text": "If a Social Security number was exposed, the IRS says tax accounts may be at risk; keep filing returns and see Form 14039 guidance if there is IRS identity theft correspondence or a duplicate-SSN rejection.",
    "sourceUrl": "https://www.irs.gov/identity-theft-fraud-scams/data-breach-information-for-taxpayers"
  },
  {
    "n": 5,
    "text": "The IRS offers an Identity Protection PIN to keep others from filing with your SSN or ITIN; it says the IRS never asks for it.",
    "sourceUrl": "https://www.irs.gov/identity-theft-fraud-scams/get-an-identity-protection-pin"
  },
  {
    "n": 6,
    "text": "For a child, the FTC describes free credit freezes for under 16s and asking the bureaus to search for a credit report in the child's name.",
    "sourceUrl": "https://consumer.ftc.gov/articles/how-protect-your-child-identity-theft"
  },
  {
    "n": 7,
    "text": "Equifax and Experian publish their own freeze pages; Equifax states freezes are free.",
    "sourceUrl": "https://www.equifax.com/personal/credit-report-services/credit-freeze/"
  },
  {
    "n": 8,
    "text": "The CFPB accepts complaints about credit reports and other financial products.",
    "sourceUrl": "https://www.consumerfinance.gov/complaint/"
  }
]
